export default __webpack_public_path__ + "static/media/forward testing.2a063286.png";